module.exports = __webpack_public_path__ + "img/bj-card-bg.b73ba569.png";